// @flow

import AuthStore from "@cabonline/shared/stores/AuthStore"

export default (new AuthStore(): any)
